import session from "../../services/session";

const Logout = () => {
  session.clear();
  window.location.replace("/login");
  return <div></div>;
};

export default Logout;
